import { createSelector, createFeatureSelector } from '@ngrx/store';

import { IComponentState } from '@models/index';

export const componentsSelector = createFeatureSelector<IComponentState>('components');
export const getNotificationSelector = createSelector(componentsSelector, (state: IComponentState) => state.notification); 
export const getLoadingSelector = createSelector(componentsSelector, (state: IComponentState) => state.loader); 
